module.exports = __webpack_public_path__ + "img/chart_logo.b9c4902c.svg";